import React, { useState, useEffect } from 'react'
import { styled } from "@mui/material/styles";
import '../../superadmin/styles/pages/dashboard.css';
import { Dialog, DialogTitle, DialogContent, DialogActions, IconButton, TextField, Button } from "@mui/material";
import Grid from "@mui/material/Grid2";
import CloseIcon from "@mui/icons-material/Close";
import instance from '../../utils/Api';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useGlobalContext } from '../../Contex'; // Adjust the path


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));

const Addadmin = ({ setAddadmins, openDialog, setOpenDialog, admin }) => {
    const { buttondisable, setButtondisable } = useGlobalContext();
    const [name, setName] = useState();
    const [phonenumber, setPhonenumber] = useState();
    const [address, setAddress] = useState();
    const [email, setEmail] = useState();
    const [password, setPassword] = useState();
    const [logo,setLogo] = useState();


    useEffect(() => {
        if (admin) {
            setName(admin.name || '');
            setEmail(admin.email || '');
            setPhonenumber(admin.phonenumber || '');
            setAddress(admin.address || '');
        } else {
            setEmail('');
            setPassword('');
            setName('');
            setPhonenumber('');
            setAddress('');
            setLogo('');
        }
    }, [admin]);

    const handleClose = () => {
        setOpenDialog(false);

        //empty value
        if (admin) {
            setName(admin.name || '');
            setEmail(admin.email || '');
            setPhonenumber(admin.phonenumber || '');
            setAddress(admin.address || '');
        } else {
            setEmail('');
            setPassword('');
            setName('');
            setPhonenumber('');
            setAddress('');
            setLogo('');
        }
    };

    // Email validation function
    const isValidEmail = (email) => {
        // Regex pattern for validating an email
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    //add schools api call
    const handleAddadmins = async () => {
        if (!email || !password || !name || !phonenumber || !address) {
            toast.error('please enter all Fields');
            return;
        }
        // Check if the email is valid
        if (!isValidEmail(email)) {
            toast.error('Please enter a valid email address');
            return;
        }
        setButtondisable(true);
        try {
            const formdata = new FormData();
            formdata.append('email',email);
            formdata.append('name',name);
            formdata.append('phonenumber',phonenumber);
            formdata.append('address',address);
            formdata.append('password',password);
            formdata.append('schoollogo',logo);
            const response = await instance.post('app/v1/school-admins/schoolAdmin/register', formdata);
            if (response.data.status === 'success') {
                toast.success(response.data.message)
                handleClose();
                setAddadmins(true); // Trigger refresh after create Admins
                setButtondisable(false);
            } else {
                toast.error(response.data.message);
                setButtondisable(false);
            }
        } catch (error) {
            // Check if the error is due to a duplicate product name
            if (error?.response?.data?.error?.includes('E11000 duplicate key error')) {
                toast.error(`Email "${email}" already exists. Please choose a different email.`);
            } else {
                toast.error(error?.response?.data?.message || 'An unexpected error occurred');
            }
            console.log(error.response);
            setButtondisable(false);
        }
    }


    //update schools api call
    const handleUpdateadmins = async () => {
        if (!email) {
            toast.error('please enter email');
            return;
        }
        if (!isValidEmail(email)) {
            toast.error('Please enter a valid email address');
            return;
        }
        setButtondisable(true);
        try {
            const formdata = new FormData();
            formdata.append('email',email);
            formdata.append('name',name);
            formdata.append('phonenumber',phonenumber);
            formdata.append('address',address);
            formdata.append('schoollogo',logo);
            const response = await instance.put(`app/v1/school-admins/schoolAdmin/update?id=${admin._id}`, formdata);
            if (response.data.success === true) {
                toast.success(response.data.message)
                handleClose();
                setAddadmins(true); // Trigger refresh after update Admins
                setButtondisable(false);
            } else {
                toast.error(response.data.message);
                setButtondisable(false);
            }
        } catch (error) {
            if (error?.response?.data?.error?.includes('E11000 duplicate key error')) {
                toast.error(`Email "${email}" already exists. Please choose a different email.`);
            } else {
                toast.error(error?.response?.data?.message || 'An unexpected error occurred');
            }
            setButtondisable(false);
        }
    }
    return (
        <React.Fragment>
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={openDialog}
                className="admin-admins"
            >
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                    {admin ? 'Update' : 'Add '} Admin
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent dividers>
                    <section>
                        <div className='add-admin'>
                            <Grid container spacing={2}>
                                <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                                    <div className='admin-textfiled'>
                                        <TextField
                                            placeholder='Enter School Name'
                                            label='School Name'
                                            type='text'
                                            fullWidth
                                            required
                                            value={name}
                                            onChange={(e) => setName(e.target.value)}
                                        />
                                    </div>
                                </Grid>
                                <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                                    <div className='admin-textfiled'>
                                        <TextField
                                            placeholder='Enter Mobile Number'
                                            label='Mobile Number'
                                            type='number'
                                            fullWidth
                                            required
                                            value={phonenumber}
                                            onChange={(e) => setPhonenumber(e.target.value)}
                                        />
                                    </div>
                                </Grid>
                                <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                                    <div className='admin-textfiled'>
                                        <TextField
                                            placeholder='Enter Address'
                                            label='Address'
                                            type='text'
                                            fullWidth
                                            required
                                            value={address}
                                            onChange={(e) => setAddress(e.target.value)}
                                        />
                                    </div>
                                </Grid>
                                <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                                    <div className='admin-textfiled'>
                                        <TextField
                                            placeholder='Enter Email Id'
                                            label='Email'
                                            type='email'
                                            fullWidth
                                            required
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                        />
                                    </div>
                                </Grid>
                                {!admin ? (<Grid item size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                                    <div className='admin-textfiled'>
                                        <TextField
                                            placeholder='Enter Password'
                                            label='Password'
                                            type='password'
                                            fullWidth
                                            required
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                        />
                                    </div>
                                </Grid>
                                ) : null}
                                <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                                    <div className='admin-textfiled'>
                                        <TextField
                                            label='School Logo'
                                            type='file'
                                            fullWidth
                                            required
                                            InputLabelProps={{ shrink: true }} // Keeps the label visible
                                            inputProps={{ accept: "image/*" }} // Accept only image files
                                            onChange={(e) => {
                                                const file = e.target.files[0];
                                                if (file) {
                                                    console.log("Selected file:", file.name);
                                                    setLogo(file);
                                                }
                                            }}
                                        />
                                    </div>
                                </Grid>
                                {/* <Grid item xs={12} sm={12} md={12} lg={12}>
                                    <div className='admin-textfiled'>
                                        <FormControl fullWidth>
                                            <InputLabel id="demo-simple-select-label">Gender</InputLabel>
                                            <Select
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                value={age}
                                                label="Gender"
                                                onChange={(e) => setAge(e.target.value)}
                                                required
                                            >
                                                <MenuItem value={10}>Ten</MenuItem>
                                                <MenuItem value={20}>Twenty</MenuItem>
                                                <MenuItem value={30}>Thirty</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </div>
                                </Grid> */}

                            </Grid>
                        </div>
                    </section>
                </DialogContent>
                <DialogActions>
                    <Button
                        className="cancel-btn"
                        onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button
                        className="add-btn" disabled={buttondisable} onClick={admin ? handleUpdateadmins : handleAddadmins}>
                        {admin ? 'Update' : 'Add'}
                    </Button>
                </DialogActions>
            </BootstrapDialog>
        </React.Fragment>
    )
}

export default Addadmin;

